import { apiFetch } from "@/lib/api";
import type {
  CoreNotification,
  CoreNotificationQueryDto,
  CoreNotificationResponse,
  CoreUnreadCountResponse,
} from "../types/core-notification.types";

export const coreNotificationApi = {
  async getAll(params?: CoreNotificationQueryDto): Promise<CoreNotificationResponse> {
    const searchParams = new URLSearchParams();

    if (params?.page) searchParams.set("page", params.page.toString());
    if (params?.limit) searchParams.set("limit", params.limit.toString());
    if (params?.read !== undefined)
      searchParams.set("read", params.read.toString());
    if (params?.type) searchParams.set("type", params.type);
    if (params?.sortBy) searchParams.set("sortBy", params.sortBy);
    if (params?.sortOrder) searchParams.set("sortOrder", params.sortOrder);

    const queryString = searchParams.toString();
    const url = queryString ? `/core-notifications?${queryString}` : "/core-notifications";

    return apiFetch(url);
  },

  async getUnreadCount(): Promise<CoreUnreadCountResponse> {
    return apiFetch("/core-notifications/unread-count");
  },

  async markAsRead(id: string): Promise<CoreNotification> {
    return apiFetch(`/core-notifications/${id}/read`, {
      method: "PATCH",
    });
  },

  async markAllAsRead(): Promise<{ count: number }> {
    return apiFetch("/core-notifications/read-all", {
      method: "PATCH",
    });
  },
};
